import Service from '@ember/service';

export default Service.extend({

  /**
   * @type {String}       The actual message that the user is typing in.
   */
  currentComposedMessageModel: '',

  subNav: {
    isTransitioning: undefined
  },

  threadSearch: {
    inputHasText: undefined,
    inputActive: undefined
  },

  threadBreakdown: {
    markUnreadAwaitingResponse: undefined,
    archiveConversationAwaitingResponse: undefined,
    restoreConversationAwaitingResponse: undefined
  },

  beginConversationComposer: {
    titleField: {},

    recipientSelector: {
      // States propagated by sh-search-field

      inputHasText: undefined,
      inputActive: undefined,

      // States propagated by user-connection-search

      active: undefined, // in the process of selecting a recipient
      editRecipientEnabled: undefined,
      isLoadingSearchResults: undefined,
    }
  },

  projectList: {
    isLoadingProjects: undefined
  },

  modals: {
    declineProject: {
      awaitingResponse: undefined,
    },
    declineOnArchive: {
      awaitingResponse: undefined,
    },
    manageWatchers: {
      awaitingResponse: undefined,
    }
  },

  /**
   * @type {Boolean} Whether the user has added uploads in the create thread mode.
   */
  hasUploadsInCreateThreadMode: false,

  /**
   * @type {Boolean} Whether the user has added uploads in the normal mode.
   */
  hasUploadsInNormalMode: false,
});
